// extracted by mini-css-extract-plugin
module.exports = {"list":"ScrapModal_list__12CkE","amountToScrap":"ScrapModal_amountToScrap__2EDgG","availableBalance":"ScrapModal_availableBalance__1HAoo","counter":"ScrapModal_counter__1e3pQ"};